module.exports = __webpack_public_path__ + "img/user-2.5b398419.svg";